/**
 * Created by lihanying on 2017/7/6.
 */
import React from 'react'
import { Table, Button } from 'antd'
import Popconfirm from '../../../components/Popconfirm/Popconfirm2'
import Modal from './modal'

export default class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false,
      userInfo: {},
      action: '-1',
    }
  }

  onShowModal = (record) => {
    this.setState({ visible: true, userInfo: record, action: '1' })
  }

  handleOk = () => {
    const { userInfo, action } = this.state
    if (action === '-1') {
      //新增
      let data = {
        account: sessionStorage.getItem('account'),
        password: sessionStorage.getItem('password'),
        employee_name: sessionStorage.getItem('employee_name'),
        employee_phone: sessionStorage.getItem('employee_phone'),
        region: sessionStorage.getItem('region_id'),
      }
      this.props.fetchAddEmployee(data)
    } else {
      //修改
      let data = {
        account_id: userInfo.id,
        account: sessionStorage.getItem('account') || userInfo.account,
        password: sessionStorage.getItem('password') || '',
        employee_name:
          sessionStorage.getItem('employee_name') || userInfo.employee_name,
        employee_phone:
          sessionStorage.getItem('employee_phone') || userInfo.employee_phone,
      }
      this.props.fetchEditEmployee(data)
    }

    this.setState({ visible: false, userInfo: {} }, () => this.clearSession())
  }

  clearSession = () => {
    sessionStorage.removeItem('account')
    sessionStorage.removeItem('password')
    sessionStorage.removeItem('employee_name')
    sessionStorage.removeItem('employee_phone')
  }

  handleCancel = () => {
    this.setState({ visible: false, userInfo: {} }, () => this.clearSession())
  }

  render() {
    const { list, regionList } = this.props
    const columns = [
      {
        title: 'id',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: '账号',
        dataIndex: 'account',
        key: 'account',
      },
      {
        title: '姓名',
        dataIndex: 'employee_name',
        key: 'employee_name',
      },
      {
        title: '电话',
        dataIndex: 'employee_phone',
        key: 'employee_phone',
      },
      {
        title: '奖金',
        dataIndex: 'bonus',
        key: 'bonus',
      },
      {
        title: '等级',
        dataIndex: 'level',
        key: 'level',
      },
      {
        title: '登录地址',
        dataIndex: 'final_login_area',
        key: 'final_login_area',
      },
      {
        title: '登录时间',
        dataIndex: 'final_login_time',
        key: 'final_login_time',
      },
      {
        title: '是否在线',
        dataIndex: 'online',
        key: 'online',
      },
      {
        title: '是否轮班',
        dataIndex: 'shift',
        key: 'shift',
      },
      {
        title: '加入时间',
        dataIndex: 'jointime',
        key: 'jointime',
      },
      {
        title: '操作',
        dataIndex: 'edit',
        key: 'edit',
        render: (text, record, index) => {
          return (
            <div style={{ color: '#108EE9', cursor: 'default' }}>
              <Button
                type="primary"
                style={{ marginRight: '10px' }}
                onClick={() => this.onShowModal(record)}
              >
                修改
              </Button>

              <Popconfirm
                title={`你确认要删除${record.account}人工账号吗?`}
                okText="确认"
                cancelText="取消"
                onConfirm={() => this.props.fetchDelEmployee(record.id)}
              >
                <Button type="primary" danger>
                  删除
                </Button>
              </Popconfirm>
            </div>
          )
        },
      },
    ]

    return (
      <div>
        <div
          style={{
            marginBottom: '20px',
          }}
        >
          <Button
            type="primary"
            onClick={() => this.setState({ visible: true, action: '-1' })}
          >
            添加员工
          </Button>
        </div>
        <Table rowKey="id" bordered columns={columns} dataSource={list} />
        {this.state.visible && (
          <Modal
            {...this.state}
            regionList={regionList}
            handleOk={this.handleOk}
            handleCancel={this.handleCancel}
          />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubEmployee/component/employee.js